import $ from 'jquery';

import SearchLoan from './search-loan-class';
import Map from './map-class';
import Tab from './tabs';

$(document).ready(function () {
    const maps = $('[data-state-map]'),
        loan = $('[search-loan]'),
        tabs = $('[data-tab]')

    if(tabs.length)
        new Tab(tabs)

    if(maps.length)
        new Map(maps)

    if(loan.length)
        new SearchLoan(loan)
})